import React, { useRef, useState } from 'react'
import * as Yup from "yup";
import {
    Modal, ModalBody, Row, Col, Form,
    Label, Input, FormGroup, Button
} from "reactstrap";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";


// components
import ItineraryComponent from "./ItineraryComponent";
import { ButtonSearchDinamic } from "../../buttons/buttonsActions";

// labels
import { CLOSE, LB_NEW_SOLICITUD, LB_RESERVATION_NUMBER, REQUIRED, SAVE } from "../../i18n/i18n";
import { xapiItineraryService } from "../../../jwt/_services/xapi/xapiItineraryService";

// actions
import { save } from "../../../redux/actions/todoFluye/wishlistActions";

const ModalNewWishlist = props => {
    const { isOpen, handleToggle } = props
    const app = props.mainState?.app?.id
    const fbDataBase = props.mainState?.app?.fbDataBase?.id
    const udn =  JSON.parse( localStorage.getItem('selectedUdn') )

    const [loadingItinerary, setLoadingItinerary] = useState(false)
    const [itinerary, setItinerary] = useState(null)
    const isMounted = useRef(true)

    const validationSchema = Yup.object().shape({
        reservationNumber: Yup.string().required( REQUIRED )
    });

    const { register, handleSubmit, errors } = useForm({
        validationSchema: validationSchema,
    });

    const onSubmit = (data, _ ) => {
        setLoadingItinerary(true)
        setItinerary(null)

        xapiItineraryService.getItinerary( data?.reservationNumber )
            .then( result => {
                if(isMounted.current)
                    setItinerary( result )
            })
            .finally( ()=> setLoadingItinerary(false) )
    }

    const onClosed = () => {
        setLoadingItinerary(false)
        setItinerary(null)
        isMounted.current = false
    }

    const onOpened = () => isMounted.current = true

    const onCreateWishlist = () => {
        if(!itinerary)
            return

        let requestData = {
            fbDataBase,
            item: {
                ...itinerary?.data,
                app,
                udn,
            }
        }

        props.save(requestData)
        handleToggle()
    }

    return <Modal
        isOpen={ isOpen }
        centered={ true }
        unmountOnClose={ true }
        onOpened={ onOpened }
        onClosed={ onClosed }
        className={'wl-modal'}
    >
        <ModalBody className={'wl-modal-body'}>
            <div className={'wl-modal-title'}>
                {LB_NEW_SOLICITUD}
            </div>

            <Form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>{ LB_RESERVATION_NUMBER }</Label>
                            <Input
                                name='reservationNumber'
                                type="test"
                                innerRef={register}
                            />
                            { errors?.reservationNumber && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.reservationNumber?.message}</div>}
                        </FormGroup>
                    </Col>
                    <Col>
                        <div className="float-left wl-modal-btn-search">
                            <ButtonSearchDinamic loading={loadingItinerary}/>
                        </div>
                    </Col>
                </Row>
            </Form>

            <ItineraryComponent itinerary={ itinerary } />

            <div className={'fex-center wl-modal-btn-actios'}>
                <Button className="btn-cancel" onClick={handleToggle}>
                    {CLOSE}
                </Button>

                {/*{
                    itinerary?.data?.additionalInfo?.enabledCreation && <Button className="btn-add" onClick={onCreateWishlist}>
                        {SAVE}
                    </Button>
                }*/}
                {
                    itinerary?.data && <Button className="btn-add" onClick={onCreateWishlist}>
                        {SAVE}
                    </Button>
                }
            </div>
        </ModalBody>
    </Modal>
}

const mapStateToProps = state => ({
    mainState: state.mainProps,
    formState: state.formProps
})
const mapActionsToProps = ({
    save
})

export default connect(mapStateToProps, mapActionsToProps)(ModalNewWishlist)